// extracted by mini-css-extract-plugin
module.exports = {"root":"i+fEAcgP","input":"xPYeG8zY","item":"dTQ8Naep","title":"PrXRkd1H","description":"M392RtW7","total":"NT7DgefC","error":"DIJ4vDUe"};